export default "__VITE_PUBLIC_ASSET__ae9272a4__"